<template>
  <moe-page>
    <moe-top ref="moeTop"></moe-top>
    <div class="teacher_content">
      <div class="teacher_top">
        <el-image class="teacher_top_bg" :src="imgPath('teacher_top_bg.png')"></el-image>
        <div class="teacher_btn cursor_pointer" @click="joinNow">立即加入</div>
      </div>
      <div class="menu_box flex Flexalign FlexBetween">
        <div class="menu_one flex flexcolumn Flexalign" v-for="(item, index) in menuList" :key="index">
          <el-image class="teacher_menu1" :src="imgPath(item.icon)"></el-image>
          <div class="menu_title mar_top_30">{{ item.title }}</div>
          <div class="menu_desc mar_top_30">{{ item.desc }}</div>
        </div>
      </div>
      <div class="form_content flex flexcolumn Flexalign">
        <div class="form_title">成为冠军课程讲师</div>
        <div class="form_desc mar_top_20">冠军高考专家诚邀优秀讲师，请您填写表单，我们将与您沟通合作细节</div>
        <div class="form_info mar_top_40">
          <div class="flex Flexalign form_one mar_bottom_30">
            <div class="form_label flex FlexjustifyEnd">
              <div class="mar_left_5">姓名</div>
              <div class="red_xing">*</div>
            </div>
            <div class="mar_left_30">
              <el-input v-model="teacherApplyInfo.name" style="width: 240px" size="large" placeholder="请输入您的姓名" />
            </div>
          </div>
          <div class="flex Flexalign form_one mar_bottom_30">
            <div class="form_label flex FlexjustifyEnd">
              <div class="mar_left_5">试讲视频</div>
              <!-- <div class="red_xing">*</div> -->
            </div>
            <div class="mar_left_30">
              <el-input v-model="teacherApplyInfo.videoDemoUrl" style="width: 240px" size="large"
                placeholder="请粘贴视频页面地址" />
            </div>
          </div>
          <div class="flex Flexalign form_one mar_bottom_30">
            <div class="form_label flex FlexjustifyEnd">
              <div class="mar_left_5">课程主题/方向/信息等</div>
              <div class="red_xing">*</div>
            </div>
            <div class="mar_left_30">
              <el-input v-model="teacherApplyInfo.desc" type="textarea" style="width: 240px" size="large"
                placeholder="请填写" />
            </div>
          </div>
          <div class="flex Flexalign form_one mar_bottom_30">
            <div class="form_label flex FlexjustifyEnd">
              <div class="mar_left_5">联系方式</div>
              <div class="red_xing">*</div>
            </div>
            <div class="mar_left_30">
              <el-input v-model="teacherApplyInfo.contactPhone" style="width: 240px" size="large"
                placeholder="请输入联系方式" @input="(e) => checkNumber(e,'contactPhone')" />
            </div>
          </div>
        </div>
        <div class="btn_submit cursor_pointer mar_top_30" @click="submit">提交</div>
      </div>
    </div>
    <moe-bottom></moe-bottom>
  </moe-page>
</template>

<script>
export default {
  name: "GjkcH5Index",

  data() {
    return {
      menuList: [
        { icon: 'teacher_menu1.png', title: '优质课程', desc: '冠军课程研发团队专业辅助 策划打造爆款课程' },
        { icon: 'teacher_menu2.png', title: '高效传播', desc: '冠军课程精准流量扶持 每期课程平均曝光量2000万+' },
        { icon: 'teacher_menu3.png', title: '讲师IP打造', desc: '专业平台权威背书 助力讲师个人IP打造' },
        { icon: 'teacher_menu4.png', title: '知识变现', desc: '收获万千学员口碑 实现知识变现&职业身份蜕变' },
      ],
      teacherApplyInfo: {
        name: "",
        videoDemoUrl: "",
        desc: "",
        contactPhone: ""
      }
    };
  },

  mounted() {
    this.topSelectedMenu = this.$Jump.getUrlParams(window.location.hash.split("?")[1]).topSelectedMenu;
    this.$refs.moeTop.topSelectedMenu = this.topSelectedMenu;
  },

  methods: {
    joinNow(){
      window.scrollTo({
        top:800,
        behavior:'smooth'
      })
    },
    checkNumber(value,type) {
      this.teacherApplyInfo[type] = value.replace(/[^0-9]/g, ""); // 移除非数字字符
    },
    submit(){
      if(!this.teacherApplyInfo.name){
        this.$Dialog.toast("请填写姓名",{type:'warning'});
        return
      }
      if(!this.teacherApplyInfo.desc){
        this.$Dialog.toast("请填写课程主题/方向/信息等",{type:'warning'});
        return
      }
      if(!this.teacherApplyInfo.contactPhone){
        this.$Dialog.toast("请填写联系方式",{type:'warning'});
        return
      }
      if (!/^1[345678]\d{9}$/.test(this.teacherApplyInfo.contactPhone)) {
        this.$Dialog.toast("请输入正确的手机号", { type: "error" });
        return;
      }
      this.$Api.user.teacherApply(this.teacherApplyInfo).then(()=>{
        this.$Dialog.toast("申请成功");
        this.back();
      }).catch(()=>{})
    }
  },
};
</script>

<style scoped lang="scss">
.teacher_content {
  width: 100%;
  min-height: calc(100vh - $pageTopHeight);
  background: #f3f3f3;

  .teacher_top {
    position: relative;

    .teacher_top_bg {
      width: 100%;
      height: 360px;
    }

    .teacher_btn {
      position: absolute;
      background-image: url("/public/static/img/teacher_btn_bg.png");
      background-size: cover;
      width: 270px;
      height: 80px;
      top: 63%;
      left: 21%;
      // font-weight: 600;
      font-size: 22px;
      color: #FFFFFF;
      text-align: center;
      line-height: 80px;
      font-family: Source Han Serif CN;
    }
  }

  .menu_box {
    // margin-top: 100px;
    width: $pageMainWidth;
    margin: 100px auto;

    .menu_one {
      .teacher_menu1 {
        width: 104px;
        height: 104px;
      }

      .menu_title {
        font-weight: 500;
        font-size: 30px;
        color: #111111;
      }

      .menu_desc {
        width: 240px;
        font-weight: 400;
        font-size: 20px;
        color: #666666;
        text-align: center;
      }
    }
  }

  .form_content {
    width: $pageMainWidth;
    margin: 0 auto;

    .form_title {
      font-size: 34px;
      color: #111111;
      font-weight: 500;
    }

    .form_desc {
      font-weight: 400;
      font-size: 20px;
      color: #999999;
    }

    .form_info {
      .form_one {
        font-size: 20px;
        color: #333333;

        .form_label {
          width: 220px;
          text-align: end;

          .red_xing {
            color: #ea2f15;
          }
        }
      }
    }
  }

  .btn_submit {
    width: 240px;
    height: 52px;
    background: linear-gradient(90deg, #00D5C2, #00D498);
    box-shadow: 0px 0px 16px 0px rgba(55, 209, 175, 0.54);
    border-radius: 26px;
    font-size: 22px;
    color: #FFFFFF;
    text-align: center;
    line-height: 52px;
    margin-bottom: 100px;
  }
}
</style>
